import Act from "../actions";
import {
  snaTimePeriodOptions,
  getDefaultStartEndDate,
  SNA_BASIC_SETTING,
} from "../../config/config.sna";
import drawNetwork from "../../pages/sna/components/main/displayArea/drawSnaLxt/drawNetwork";

const initState = {
  sidebar: {
    open: true,
    contentName: "file", // group, file, filter, adjust, analytics
  },
  sidebarFileTool: {
    tabIdx: 1, // 0:個人, 1:團隊
  },
  evnCtgSettingToolIsLoading: false,
  dialogContext: {
    openSignal: false,
    title: "",
    contentText: "",
    yesText: "yes",
    noText: "no",
    onYes: () => null,
    onNo: () => null,
    onClose: () => null,
  },
  editDialog: {
    open: false,
    type: "",
    title: "",
    content: "",
    deletedTableData: [],
    curMainEvn: "",
    curRowId: "",
    evtTypeId: "",
  },
  evnCtgDialog: false,
  //
  refreshPublicDataset: false,
  refreshPersonalDataset: false,
  refreshGroupDataset: false,
  //
  applyFetchDataset: true,
  applyAdjustSetting: true,
  applyFilterSetting: true,
  applyAnalytics: false,
  //
  snaDisplay: {
    snaRef: null,
    drawNetworkData: {}, // {links:[],nodes:[],curGroups:[],curSubGroups:[]}
    memoSnaWidth: null,
    memoSnaHeight: null,
    focusNodes: [], // 被 focus 的 nodes
  },
  // dataset tool
  dataset: {
    group: null, // 團隊的資料集 [{id:"",displayName:"",...}]
    public: null, // 平台公開的資料集
    personal: null, // 個人的資料集
    select: null, // 選定的資料集
  },
  // adjust tool
  adjust: {
    nodeColors: {
      initial: SNA_BASIC_SETTING.adjust_nodeColors,
      change: SNA_BASIC_SETTING.adjust_nodeColors,
    },
    linkColors: {
      initial: SNA_BASIC_SETTING.adjust_linkColors,
      change: SNA_BASIC_SETTING.adjust_linkColors,
    },
    nodePlaceMode: {
      initial: SNA_BASIC_SETTING.adjust_nodePlaceMode,
      change: SNA_BASIC_SETTING.adjust_nodePlaceMode,
    },
    nodeShowNodeCount: {
      initial: SNA_BASIC_SETTING.adjust_nodeShowNodeCount,
      change: SNA_BASIC_SETTING.adjust_nodeShowNodeCount,
    },
    nodeDispersion: {
      initial: SNA_BASIC_SETTING.adjust_nodeDispersion,
      change: SNA_BASIC_SETTING.adjust_nodeDispersion,
    },
    legendShowNodDataGroup: {
      initial: SNA_BASIC_SETTING.adjust_legendShowNodDataGroup,
      change: SNA_BASIC_SETTING.adjust_legendShowNodDataGroup,
    },
  },
  // filter tool
  filter: {
    // 是否開啟事件分類功能
    filterEventTypeOn: {
      initial: false,
      change: false,
    },
    eventTypes: {
      initial: null,
      change: null,
      origin: null,
      custom: null,
    },
    nodeCount: {
      initial: SNA_BASIC_SETTING.filter_nodeCount,
      change: SNA_BASIC_SETTING.filter_nodeCount,
    },
    linkCount: {
      initial: SNA_BASIC_SETTING.filter_linkCount,
      change: SNA_BASIC_SETTING.filter_linkCount,
    },
    limitTotalNodesCount: {
      initial: SNA_BASIC_SETTING.filter_limitTotalNodesCount,
      change: SNA_BASIC_SETTING.filter_limitTotalNodesCount,
    },
    timePeriod: {
      initial: SNA_BASIC_SETTING.filter_timePeriod,
      change: SNA_BASIC_SETTING.filter_timePeriod,
    },
    startEndDate: {
      initial: SNA_BASIC_SETTING.filter_startEndDate,
      change: SNA_BASIC_SETTING.filter_startEndDate,
    },
    nodeAuthorPreserve: {
      initial: [], // [{authorId:"PER0",authorLabel:"林獻堂",checked:true},{}]
      change: [],
    },
    // nodeCountMeetAuth: {
    //   initial: SNA_BASIC_SETTING.filter_nodeCountMeetAuth,
    //   change: SNA_BASIC_SETTING.filter_nodeCountMeetAuth,
    // },
    nodeCountMeetAuthNew: {
      initial: SNA_BASIC_SETTING.filter_nodeCountMeetAuthNew,
      change: SNA_BASIC_SETTING.filter_nodeCountMeetAuthNew,
    },
  },
  // analytics tool
  analytics: {
    analyticsType: {
      initial: SNA_BASIC_SETTING.analytics_type,
      change: SNA_BASIC_SETTING.analytics_type,
    },
    startAnalysis: false,
    displayWindow: false, // 是否顯示視窗
  },
  // 日記事件詳細資訊
  diaryInfo: {
    eventList: [],
    /* pages */
    currentPage: 1, // 當前頁碼
    pages: {
      limit: 5,
      offset: 0,
      rowsPerPage: 5, // enum[5,10,15]
    },
    curPageRows: null,
    displayWindow: false, // 是否顯示視窗
    startSearch: false, // 開始搜尋
  },
  // export tool
  export: {
    startExportFile: SNA_BASIC_SETTING.export_startExportFile, // file, image
    startExportImage: SNA_BASIC_SETTING.export_startExportImage, // file, image
    imageResolution: SNA_BASIC_SETTING.export_imageResolution,
    imageMineType: SNA_BASIC_SETTING.export_imageMineType,
    fileMineType: SNA_BASIC_SETTING.export_fileMineType,
  },
  // import tool
  import: {},
  // subpage
  subPage: "ocr",
  AI: {
    currentPage: "main",
    InputTxt: "",
    isFetch: false,
    fetchData: [],
    isWatchingInput: false,
    tableData: [
      {
        source: "",
        srcId: "",
        srcLabel: "",
        dstId: "",
        dstLabel: "",
        mainEvn: "",
        subEvn: "",
        relationship: "",
      },
    ],
    totalPage: 1,
    curTablePage: 1,
    itemPerPage: 4,
  },
  quota: {
    ai: false,
    ocr: false,
  },
  ocrSignal: new Date(),
  quotaNumber: 0,
};

const snaReducer = (state = initState, action) => {
  switch (action.type) {
    case Act.SNA_SIDE_BAR:
      return { ...state, sidebar: action.payload };
    case Act.SNA_SIDEBAR_FILE_TOOL:
      return { ...state, sidebarFileTool: action.payload };
    case Act.SNA_SET_EVN_CTG_SETTING_TOOL_ISLOADING:
      return { ...state, evnCtgSettingToolIsLoading: action.payload };
    case Act.SNA_DIALOG_CONTEXT:
      return { ...state, dialogContext: action.payload };
    case Act.SNA_SET_EDIT_DIALOG:
      return { ...state, editDialog: action.payload };
    case Act.SNA_SET_EVN_CTG_DIALOG:
      return { ...state, evnCtgDialog: action.payload };

    /* display area */
    case Act.SNA_DISPLAY_SNA_REF:
      return {
        ...state,
        snaDisplay: {
          ...state.snaDisplay,
          snaRef: action.payload,
        },
      };
    case Act.SNA_DISPLAY_DRAW_NETWORK_DATA:
      return {
        ...state,
        snaDisplay: {
          ...state.snaDisplay,
          drawNetworkData: action.payload,
        },
      };
    case Act.SNA_DISPLAY_MEMO_WIDTH:
      return {
        ...state,
        snaDisplay: {
          ...state.snaDisplay,
          memoSnaWidth: action.payload,
        },
      };
    case Act.SNA_DISPLAY_MEMO_HEIGHT:
      return {
        ...state,
        snaDisplay: {
          ...state.snaDisplay,
          memoSnaHeight: action.payload,
        },
      };
    case Act.SNA_DISPLAY_FOCUS_NODES:
      return {
        ...state,
        snaDisplay: {
          ...state.snaDisplay,
          focusNodes: action.payload,
        },
      };

    /* refresh dataset */
    case Act.SNA_REFRESH_PUBLIC_DATASET:
      return { ...state, refreshPublicDataset: action.payload };
    case Act.SNA_REFRESH_GROUP_DATASET:
      return { ...state, refreshGroupDataset: action.payload };
    case Act.SNA_REFRESH_PERSONAL_DATASET:
      return { ...state, refreshPersonalDataset: action.payload };
    /* apply action */
    case Act.SNA_APPLY_FETCH_DATASET:
      return { ...state, applyFetchDataset: action.payload };
    case Act.SNA_APPLY_ADJUST_SETTING:
      return { ...state, applyAdjustSetting: action.payload };
    case Act.SNA_APPLY_FILTER_SETTING:
      return { ...state, applyFilterSetting: action.payload };
    case Act.SNA_APPLY_ANALYTICS:
      return { ...state, applyAnalytics: action.payload };

    /* file tool */
    case Act.SNA_CUR_DATASET:
      return { ...state, dataset: action.payload };
    case Act.SNA_CUR_DATASET_CLEAR:
      return { ...state, dataset: initState.dataset };
    case Act.SNA_DATASET_PUBLIC:
      return {
        ...state,
        dataset: { ...state.dataset, public: action.payload },
      };
    case Act.SNA_DATASET_GROUP:
      return {
        ...state,
        dataset: { ...state.dataset, group: action.payload },
      };
    case Act.SNA_DATASET_PERSONAL:
      return {
        ...state,
        dataset: { ...state.dataset, personal: action.payload },
      };

    /* adjust tool */
    // node color
    case Act.SNA_ADJUST_NODE_COLORS_INITIAL:
      return {
        ...state,
        adjust: {
          ...state.adjust,
          nodeColors: {
            ...state.adjust.nodeColors,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_ADJUST_NODE_COLORS_CHANGE:
      return {
        ...state,
        adjust: {
          ...state.adjust,
          nodeColors: {
            ...state.adjust.nodeColors,
            change: action.payload,
          },
        },
      };
    // link color
    case Act.SNA_ADJUST_LINK_COLORS_INITIAL:
      return {
        ...state,
        adjust: {
          ...state.adjust,
          linkColors: {
            ...state.adjust.linkColors,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_ADJUST_LINK_COLORS_CHANGE:
      return {
        ...state,
        adjust: {
          ...state.adjust,
          linkColors: {
            ...state.adjust.linkColors,
            change: action.payload,
          },
        },
      };
    // node placement
    case Act.SNA_ADJUST_NODE_PLACEMENT_INITIAL:
      return {
        ...state,
        adjust: {
          ...state.adjust,
          nodePlaceMode: {
            ...state.adjust.nodePlaceMode,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_ADJUST_NODE_PLACEMENT_CHANGE:
      return {
        ...state,
        adjust: {
          ...state.adjust,
          nodePlaceMode: {
            ...state.adjust.nodePlaceMode,
            change: action.payload,
          },
        },
      };
    // node show node count
    case Act.SNA_ADJUST_NODE_SHOW_NODE_COUNT_INITIAL:
      return {
        ...state,
        adjust: {
          ...state.adjust,
          nodeShowNodeCount: {
            ...state.adjust.nodeShowNodeCount,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_ADJUST_NODE_SHOW_NODE_COUNT_CHANGE:
      return {
        ...state,
        adjust: {
          ...state.adjust,
          nodeShowNodeCount: {
            ...state.adjust.nodeShowNodeCount,
            change: action.payload,
          },
        },
      };
    // node dispersion
    case Act.SNA_ADJUST_NODE_DISPERSION_INITIAL:
      return {
        ...state,
        adjust: {
          ...state.adjust,
          nodeDispersion: {
            ...state.adjust.nodeDispersion,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_ADJUST_NODE_DISPERSION_CHANGE:
      return {
        ...state,
        adjust: {
          ...state.adjust,
          nodeDispersion: {
            ...state.adjust.nodeDispersion,
            change: action.payload,
          },
        },
      };
    // legend show no data group
    case Act.SNA_ADJUST_LEGEND_SHOW_NO_DATA_GROUP_INITIAL:
      return {
        ...state,
        adjust: {
          ...state.adjust,
          legendShowNodDataGroup: {
            ...state.adjust.legendShowNodDataGroup,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_ADJUST_LEGEND_SHOW_NO_DATA_GROUP_CHANGE:
      return {
        ...state,
        adjust: {
          ...state.adjust,
          legendShowNodDataGroup: {
            ...state.adjust.legendShowNodDataGroup,
            change: action.payload,
          },
        },
      };

    /* filter tool */
    case Act.SNA_EVENT_TYPES_FILTER_ON_INITIAL:
      return {
        ...state,
        filter: {
          ...state.filter,
          filterEventTypeOn: {
            ...state.filter.filterEventTypeOn,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_EVENT_TYPES_FILTER_ON_CHANGE:
      return {
        ...state,
        filter: {
          ...state.filter,
          filterEventTypeOn: {
            ...state.filter.filterEventTypeOn,
            change: action.payload,
          },
        },
      };
    // eventTypes
    case Act.SNA_EVENT_TYPES_INITIAL:
      return {
        ...state,
        filter: {
          ...state.filter,
          eventTypes: {
            ...state.filter.eventTypes,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_EVENT_TYPES_CHANGE:
      return {
        ...state,
        filter: {
          ...state.filter,
          eventTypes: {
            ...state.filter.eventTypes,
            change: action.payload,
          },
        },
      };
    case Act.SNA_EVENT_TYPES_ORIGIN:
      return {
        ...state,
        filter: {
          ...state.filter,
          eventTypes: {
            ...state.filter.eventTypes,
            origin: action.payload,
          },
        },
      };
    case Act.SNA_EVENT_TYPES_CUSTOM:
      return {
        ...state,
        filter: {
          ...state.filter,
          eventTypes: {
            ...state.filter.eventTypes,
            custom: action.payload,
          },
        },
      };
    // node count
    case Act.SNA_FILTER_NODE_COUNT_INITIAL:
      return {
        ...state,
        filter: {
          ...state.filter,
          nodeCount: {
            ...state.filter.nodeCount,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_FILTER_NODE_COUNT_CHANGE:
      return {
        ...state,
        filter: {
          ...state.filter,
          nodeCount: {
            ...state.filter.nodeCount,
            change: action.payload,
          },
        },
      };
    // link count
    case Act.SNA_FILTER_LINK_COUNT_INITIAL:
      return {
        ...state,
        filter: {
          ...state.filter,
          linkCount: {
            ...state.filter.linkCount,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_FILTER_LINK_COUNT_CHANGE:
      return {
        ...state,
        filter: {
          ...state.filter,
          linkCount: {
            ...state.filter.linkCount,
            change: action.payload,
          },
        },
      };

    // limitTotalNodesCount
    case Act.SNA_FILTER_LIMIT_TOTAL_NODES_INITIAL:
      return {
        ...state,
        filter: {
          ...state.filter,
          limitTotalNodesCount: {
            ...state.filter.limitTotalNodesCount,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_FILTER_LIMIT_TOTAL_NODES_CHANGE:
      return {
        ...state,
        filter: {
          ...state.filter,
          limitTotalNodesCount: {
            ...state.filter.limitTotalNodesCount,
            change: action.payload,
          },
        },
      };

    // time period
    case Act.SNA_FILTER_TIME_PERIOD_INITIAL:
      return {
        ...state,
        filter: {
          ...state.filter,
          timePeriod: {
            ...state.filter.timePeriod,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_FILTER_TIME_PERIOD_CHANGE:
      return {
        ...state,
        filter: {
          ...state.filter,
          timePeriod: {
            ...state.filter.timePeriod,
            change: action.payload,
          },
        },
      };
    // startEndDate
    case Act.SNA_FILTER_START_END_DATE_INITIAL:
      return {
        ...state,
        filter: {
          ...state.filter,
          startEndDate: {
            ...state.filter.startEndDate,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_FILTER_START_END_DATE_CHANGE:
      return {
        ...state,
        filter: {
          ...state.filter,
          startEndDate: {
            ...state.filter.startEndDate,
            change: action.payload,
          },
        },
      };
    // nodeAuthorPreserve
    case Act.SNA_FILTER_NODE_AUTHOR_PRESERVE_INITIAL:
      return {
        ...state,
        filter: {
          ...state.filter,
          nodeAuthorPreserve: {
            ...state.filter.nodeAuthorPreserve,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_FILTER_NODE_AUTHOR_PRESERVE_CHANGE:
      return {
        ...state,
        filter: {
          ...state.filter,
          nodeAuthorPreserve: {
            ...state.filter.nodeAuthorPreserve,
            change: action.payload,
          },
        },
      };
    // nodeCountMeetAuth
    // case Act.SNA_FILTER_NODE_COUNT_MEET_AUTH_INITIAL:
    //   return {
    //     ...state,
    //     filter: {
    //       ...state.filter,
    //       nodeCountMeetAuth: {
    //         ...state.filter.nodeCountMeetAuth,
    //         initial: action.payload,
    //       },
    //     },
    //   };
    // case Act.SNA_FILTER_NODE_COUNT_MEET_AUTH_CHANGE:
    //   return {
    //     ...state,
    //     filter: {
    //       ...state.filter,
    //       nodeCountMeetAuth: {
    //         ...state.filter.nodeCountMeetAuth,
    //         change: action.payload,
    //       },
    //     },
    //   };
    // nodeCountDefNew
    case Act.SNA_FILTER_NODE_COUNT_MEET_AUTH_NEW_INITIAL:
      return {
        ...state,
        filter: {
          ...state.filter,
          nodeCountMeetAuthNew: {
            ...state.filter.nodeCountMeetAuthNew,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_FILTER_NODE_COUNT_MEET_AUTH_CHANGE_NEW:
      return {
        ...state,
        filter: {
          ...state.filter,
          nodeCountMeetAuthNew: {
            ...state.filter.nodeCountMeetAuthNew,
            change: action.payload,
          },
        },
      };
    /* analytics tool */
    case Act.SNA_ANALYTICS_TYPE_INITIAL:
      return {
        ...state,
        analytics: {
          ...state.analytics,
          analyticsType: {
            ...state.analytics.analyticsType,
            initial: action.payload,
          },
        },
      };
    case Act.SNA_ANALYTICS_TYPE_CHANGE:
      return {
        ...state,
        analytics: {
          ...state.analytics,
          analyticsType: {
            ...state.analytics.analyticsType,
            change: action.payload,
          },
        },
      };
    case Act.SNA_ANALYTICS_START_ANALYSIS:
      return {
        ...state,
        analytics: {
          ...state.analytics,
          startAnalysis: action.payload,
        },
      };
    case Act.SNA_ANALYTICS_DISPLAY_WINDOW:
      return {
        ...state,
        analytics: {
          ...state.analytics,
          displayWindow: action.payload,
        },
      };
    /* 日記事件詳細資訊 */
    case Act.SNA_DIARY_INFO_EVENT_LIST:
      return {
        ...state,
        diaryInfo: {
          ...state.diaryInfo,
          eventList: action.payload,
        },
      };
    case Act.SNA_DIARY_INFO_CUR_PAGE:
      return {
        ...state,
        diaryInfo: {
          ...state.diaryInfo,
          currentPage: action.payload,
        },
      };
    case Act.SNA_DIARY_INFO_PAGES:
      return {
        ...state,
        diaryInfo: {
          ...state.diaryInfo,
          pages: {
            ...state.pages,
            ...(action.payload || {}),
          },
        },
      };
    case Act.SNA_DIARY_INFO_CUR_PAGE_ROWS:
      return {
        ...state,
        diaryInfo: {
          ...state.diaryInfo,
          curPageRows: action.payload,
        },
      };
    case Act.SNA_DIARY_INFO_DISPLAY_WINDOW:
      return {
        ...state,
        diaryInfo: {
          ...state.diaryInfo,
          displayWindow: action.payload,
        },
      };
    case Act.SNA_DIARY_INFO_START_SEARCH:
      return {
        ...state,
        diaryInfo: {
          ...state.diaryInfo,
          startSearch: action.payload,
        },
      };
    /* import tool */

    /* export tool */
    case Act.SNA_EXPORT_IMAGE_RESOLUTION:
      return {
        ...state,
        export: {
          ...state.export,
          imageResolution: action.payload,
        },
      };
    case Act.SNA_EXPORT_IMAGE_MINE_TYPE:
      return {
        ...state,
        export: {
          ...state.export,
          imageMineType: action.payload,
        },
      };
    case Act.SNA_EXPORT_FILE_MINE_TYPE:
      return {
        ...state,
        export: {
          ...state.export,
          fileMineType: action.payload,
        },
      };
    case Act.SNA_EXPORT_START_EXPORT_FILE:
      return {
        ...state,
        export: {
          ...state.export,
          startExportFile: action.payload,
        },
      };
    case Act.SNA_EXPORT_START_EXPORT_IMAGE:
      return {
        ...state,
        export: {
          ...state.export,
          startExportImage: action.payload,
        },
      };
    case Act.SNA_SET_SUBPAGE:
      return {
        ...state,
        subPage: action.payload,
      };
    case Act.SNA_SET_AI_CURRENT_PAGE:
      return {
        ...state,
        AI: { ...state.AI, currentPage: action.payload },
      };
    case Act.SNA_SET_AI_INPUT_TXT:
      return {
        ...state,
        AI: { ...state.AI, InputTxt: action.payload },
      };
    case Act.SNA_SET_AI_IS_FETCH_DATA:
      return {
        ...state,
        AI: { ...state.AI, isFetch: action.payload },
      };
    case Act.SNA_SET_AI_FETCH_DATA:
      return {
        ...state,
        AI: { ...state.AI, fetchData: action.payload },
      };
    case Act.SNA_SET_OCR_QUOTA:
      return {
        ...state,
        quota: { ...state.quota, ocr: action.payload },
      };
    case Act.SNA_SET_AI_QUOTA:
      return {
        ...state,
        quota: { ...state.quota, ai: action.payload },
      };
    case Act.SNA_SET_QUOTA:
      return {
        ...state,
        quotaNumber: action.payload,
      };
    case Act.SNA_SET_AI_IS_WATCHING_INPUT:
      return {
        ...state,
        AI: { ...state.AI, isWatchingInput: action.payload },
      };
    case Act.SNA_SET_AI_TABLE_DATA:
      return { ...state, AI: { ...state.AI, tableData: action.payload } };
    case Act.SNA_SET_AI_TABLE_TOTAL_PAGE:
      return {
        ...state,
        AI: { ...state.AI, totalPage: action.payload },
      };
    case Act.SNA_SET_AI_TABLE_CURRENT_PAGE:
      return {
        ...state,
        AI: { ...state.AI, curTablePage: action.payload },
      };
    case Act.SNA_SET_AI_TABLE_ITEM_PER_PAGE:
      return {
        ...state,
        AI: { ...state.AI, itemPerPage: action.payload },
      };
    default:
      return state;
  }
};
export default snaReducer;
